module.exports = __webpack_public_path__ + "img/daishengxiao.37f0c044.png";